import React, { useState } from 'react';
import AppSnackbar from '../../../common/AppSnackbar';

import HeaderTitleEdit from '../../../common/HeaderTitleEdit';
import ProductRenameDialog from '../dialogs/ProductRenameDialog';
import { Product } from '../Product.interface';

export interface ProductHeaderTitleProps {
  children?: React.ReactNode;
  product: Product | undefined;
  onChange?: (product: Partial<Product>) => void;
}

const ProductHeaderTitle: React.FC<ProductHeaderTitleProps> = (
  props: ProductHeaderTitleProps
) => {
  const { children, product, onChange } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [didUpdate, setDidUpdate] = useState<boolean>(false);

  return (
    <>
      <HeaderTitleEdit
        children={children}
        disabled={!product}
        onClick={() => setOpen(true)}
      />
      {product && (
        <ProductRenameDialog
          open={open}
          product={product}
          onChange={onChange}
          onCancel={() => setOpen(false)}
          onUpdate={() => {
            setOpen(false);
            setDidUpdate(true);
          }}
        />
      )}
      <AppSnackbar
        open={didUpdate}
        severity='success'
        onClose={() => setDidUpdate(false)}
      >
        Product name updated.
      </AppSnackbar>
    </>
  );
};

export default ProductHeaderTitle;
